import { AuthenticationTriggerWrapper } from '@/components/buttons/AuthenticationTriggerWrapper';
import { useMarketplaceChain } from '@/hooks/use-marketplace-chain';
import { useAuthentication } from '@/hooks/useAuthentication';
import { ReservoirAction } from '@/utils/reservoir';
import { Button, ButtonProps } from '@chakra-ui/react';
import { BuyModal, BuyStep } from '@sphere/reservoir-kit-ui';
import {
  ReactElement,
  useState,
  type ComponentPropsWithoutRef,
  type FC,
  type ReactNode,
} from 'react';
import ActionDisabledTooltip from './ActionDisabledTooltip';

type Props = ButtonProps & {
  tokenId?: string;
  collectionId?: string;
  orderId?: string;
  buttonChildren?: ReactNode;
  mutate?: () => void;
  openState?: ComponentPropsWithoutRef<typeof BuyModal>['openState'];
  trigger?: ReactElement<ReactNode>;
  onGoToToken?: () => void;
};

const BuyNow: FC<Props> = ({
  tokenId,
  collectionId,
  orderId = undefined,
  mutate,
  buttonChildren,
  openState,
  trigger,
  onGoToToken,
  ...props
}) => {
  const { authenticate } = useAuthentication();
  const marketplaceChain = useMarketplaceChain();
  const defaultOpenState = useState(false);

  const WrappedTrigger = (
    <ActionDisabledTooltip action={ReservoirAction.Buy}>
      {trigger || (
        <Button w="full" data-testid="buy-button-pdp" {...props}>
          {buttonChildren}
        </Button>
      )}
    </ActionDisabledTooltip>
  );

  return (
    <AuthenticationTriggerWrapper trigger={WrappedTrigger}>
      <BuyModal
        trigger={WrappedTrigger}
        tokenId={tokenId}
        collectionId={collectionId}
        orderId={orderId}
        openState={openState || defaultOpenState}
        onConnectWallet={authenticate}
        chainId={marketplaceChain.id}
        onClose={(data, stepData, currentStep) => {
          if (mutate && currentStep == BuyStep.Complete) mutate();
        }}
        onGoToToken={onGoToToken}
        onAddFunds={() => marketplaceChain.onAddFunds(openState || defaultOpenState)}
      />
    </AuthenticationTriggerWrapper>
  );
};

export default BuyNow;
